import React from 'react';
import { StyleSheet, View } from 'react-native';
import { BalanceCard, IllusCredit_2, theme, useResponsive } from '@sg/garnish';

import { useLocalizationContext } from '@order/Localization';

import { RedeemGiftCardForm } from '../RedeemGiftCardForm';
import {
  GiftCardAccountSectionAddCardCta,
  GiftCardAccountSectionContainer,
  GiftCardAccountSectionGiftCardTotal,
} from './components';
import { useGiftCardBalance } from './hooks';

// ─────────────────────────────────────────────────────────────────────────────

export const GiftCardAccountSection = () => {
  const { minWidth } = useResponsive();
  const { balance, isFetching } = useGiftCardBalance();

  // ─────────────────────────────────────────────────────────────────────

  if (minWidth.isSM)
    return (
      <GiftCardAccountSectionSM
        giftCardBalance={balance}
        isFetching={isFetching}
      />
    );

  return (
    <GiftCardAccountSectionXS
      giftCardBalance={balance}
      isFetching={isFetching}
    />
  );
};

// ─── Responsive Components ───────────────────────────────────────────────────

export const GiftCardAccountSectionXS = (
  props: GiftCardAccountSectionProps,
) => {
  const { isFetching, giftCardBalance } = props;

  return (
    <GiftCardAccountSectionContainer>
      <GiftCardAccountSectionGiftCardTotal
        totalAmount={giftCardBalance}
        isFetching={isFetching}
      />
      <GiftCardAccountSectionAddCardCta />
    </GiftCardAccountSectionContainer>
  );
};

export const GiftCardAccountSectionSM = (
  props: GiftCardAccountSectionProps,
) => {
  const { isFetching, giftCardBalance } = props;

  const { t } = useLocalizationContext();

  // ─────────────────────────────────────────────────────────────────────

  return (
    <GiftCardAccountSectionContainer>
      <View style={styles.cardContainer}>
        <BalanceCard
          title={t('account.gift-cards.gift-card-total')}
          balance={giftCardBalance}
          illustrationSource={IllusCredit_2}
          isLoading={isFetching}
        />
      </View>

      <View style={styles.formContainer}>
        <RedeemGiftCardForm />
      </View>
    </GiftCardAccountSectionContainer>
  );
};

//

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  cardContainer: {
    alignItems: 'center',
    paddingTop: theme.spacing['6'],
    paddingBottom: theme.spacing['12'],
  },
  formContainer: {
    paddingBottom: theme.spacing['6'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type GiftCardAccountSectionProps = Readonly<{
  giftCardBalance: string;
  isFetching: boolean;
}>;
